import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import { TravelerBuilding } from '../types';

interface TravelerJobDetailsProps {
  building: TravelerBuilding;
}

const readOnlyInputSx = {
  '& .MuiInputBase-input': {
    fontSize: '13px',
    padding: '6px 10px',
    bgcolor: '#f5f5f5',
    color: '#333',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: '#ccc' },
  },
  width: '70px',
};

const readOnlyInputProps = { readOnly: true } as const;

const pdfPlaceholderSx = {
  display: 'none',
  fontSize: '13px',
  color: '#333',
  bgcolor: '#f5f5f5',
  border: '1px solid #ccc',
  borderRadius: '4px',
  padding: '6px 10px',
  minWidth: '70px',
  textAlign: 'center',
} as const;

const TravelerJobDetails = ({ building }: TravelerJobDetailsProps) => {
  return (
    <Box
      sx={{
        bgcolor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        p: '16px 20px',
        mb: 2.5,
      }}
    >
      <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', mb: 1.5 }}>
        Job Details
      </Typography>
      <Box
        sx={{
          border: '1px solid #999',
          p: '12px 16px',
          bgcolor: '#fafafa',
          position: 'relative',
        }}
      >
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: 600,
            color: '#666',
            textTransform: 'uppercase',
            bgcolor: '#fafafa',
            display: 'inline-block',
            px: 0.5,
            mt: '-20px',
            mb: 1.5,
          }}
        >
          Building Information
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px 32px',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: '13px' }}>Geographic Location:</Typography>
            <TextField
              value={building.geographicLocation ?? '—'}
              size="small"
              InputProps={readOnlyInputProps}
              sx={readOnlyInputSx}
            />
            <Box className="pdf-pending-placeholder" sx={pdfPlaceholderSx}>
              {building.geographicLocation ?? '—'}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: '13px' }}>Live Load:</Typography>
            <TextField
              value={building.liveLoad}
              size="small"
              InputProps={readOnlyInputProps}
              sx={readOnlyInputSx}
            />
            <Box className="pdf-pending-placeholder" sx={pdfPlaceholderSx}>
              {building.liveLoad}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: '13px' }}>Dead Load:</Typography>
            <TextField
              value={building.deadLoad}
              size="small"
              InputProps={readOnlyInputProps}
              sx={readOnlyInputSx}
            />
            <Box className="pdf-pending-placeholder" sx={pdfPlaceholderSx}>
              {building.deadLoad}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: '13px' }}>Wind Speed (MPH):</Typography>
            <TextField
              value={building.windSpeed}
              size="small"
              InputProps={readOnlyInputProps}
              sx={readOnlyInputSx}
            />
            <Box className="pdf-pending-placeholder" sx={pdfPlaceholderSx}>
              {building.windSpeed}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: '13px' }}>Snow Load (PSF):</Typography>
            <TextField
              value={building.snowLoad}
              size="small"
              InputProps={readOnlyInputProps}
              sx={readOnlyInputSx}
            />
            <Box className="pdf-pending-placeholder" sx={pdfPlaceholderSx}>
              {building.snowLoad}
            </Box>
          </Box>
          <FormControlLabel
            control={<Checkbox checked={building.confirmedLoadRating} disabled size="small" />}
            label={<Typography sx={{ fontSize: '13px' }}>Confirm Load Rating</Typography>}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TravelerJobDetails;
